<template>
  <div>
    <div class="page-main has-bottom">
      <page-title />
      <div class="init-page">
        <page-card>
          <template slot="header"> Well Information </template>
          <div slot="body" v-loading="loading">
            <wellComp ref="addWellComp" type="edit" :remove-disabled="true" />
          </div>
        </page-card>
      </div>
    </div>
    <page-bottom>
      <template>
        <div class="page-btns">
          <el-button @click="goback">Cancel</el-button>
          <loading-btn label="Submit" type="primary" @clickHandle="submit" />
        </div>
      </template>
    </page-bottom>
  </div>
</template>

<script>
import wellComp from './components/well.vue'
import { wellList } from '@/api/well.js'
export default {
  components: {
    wellComp
  },
  data() {
    return {
      loading: false,
      pageData: {}
    }
  },
  created() {
    // this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading = true
      const param = {
        wellID: this.$route.query.wellID
      }
      wellList(param)
        .then((res) => {
          this.pageData = res.result || {}
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    goback() {
      this.$router.push('/wellManagement/myWells')
    },
    submit(btn) {
      this.loading = true
      Promise.all([
        this.$refs.addWellComp.editSubmit(),
        this.$refs.addWellComp.handleUpdateProducer()
      ])
        .then((res) => {
          this.$message.success('Submitted successfully!')
          btn.closeLoad()
          this.loading = false
          this.goback()
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          btn.closeLoad()
        })
    }
  }
}
</script>
<style scoped></style>
